//export a divider component that has a height prop and shows a horizontal line with the given height

export default function Divider({ className }) {
  return <div className={`w-full border-b border-bordered my-2 ${className}`}></div>
}
